import { defineComponent as _defineComponent } from 'vue'
import { useBiScroll } from '@/helpers/composables/useBiScroll';
import { computed, ref, toRefs } from 'vue';

import type { LoadMorePayload } from '@/helpers/composables/useBiScroll';

import PaginationNav from '@/components/nav/PaginationNav.vue';

interface InfiniteBiScrollProps {
	paginationLevel: 0 | 1 | 2;
	loading: boolean;
	pageSize: number;
	titlesAmount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfiniteBiScroll',
  props: {
    paginationLevel: null,
    loading: { type: Boolean },
    pageSize: null,
    titlesAmount: { default: 0 }
  },
  emits: ["load-next", "load-prev"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'load-next' | 'load-prev', payload: LoadMorePayload): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { paginationLevel: 0 | 1 | 2, loading: boolean, pageSize: number, titlesAmount: number };



const enabled = computed(() => props.paginationLevel > 0);

// emits an event with payload to stay compatible with <CustomIonInfiniteScroll>
// that uses event.target?.complete() after loadMore() events.


const el = ref<HTMLElement | null>(null);

const onEmit = (eventName: 'load-next' | 'load-prev', payload: LoadMorePayload) => {
	emit(eventName, payload);
};

function pageNumber(pageStart: number, index: number, titlesPerPage: number) {
	return Math.floor(pageStart - 1 + (index / titlesPerPage + 1));
}

const { page, pageStart, lastPage, loadingPrev, loadingNext, anyLoading, ANCHOR_NAME } = useBiScroll(
	el,
	toRefs(props),
	onEmit
);

return { __sfc: true,props, enabled, emit, el, onEmit, pageNumber, page, pageStart, lastPage, loadingPrev, loadingNext, anyLoading, ANCHOR_NAME, PaginationNav }
}

})